import React from 'react';
import { getPointsColor, getRoundedPercent, getRoundedPercentToWholeNumber } from 'utils/numbers';
import TooltipCustom from 'components/common/Tooltip/Tooltip';
import { declinationOfNumber } from 'utils/declination';
import styles from './styles.module.scss';
import { translate } from '../../../localizations';
import ScorePercent from './components/ScorePercent/ScorePercent';
import { IconQuestion } from 'shared/ui';

interface IOwnProps {
	minPoints: number;
	maxPoints: number;
	points: number;
	pointsPercent: number;
	language: string;
}

const ScoreMinMax: React.FC<IOwnProps> = ({ minPoints, maxPoints, points, pointsPercent, language }) => {
	let condition;
	if (pointsPercent !== null) {
		condition = getPointsColor(pointsPercent);
	}

	const declinationArray: string[] = [
		translate('score_1', language),
		translate('score_24', language),
		translate('score_many', language),
	];

	const localMinPoints = getRoundedPercent(minPoints);
	const localMaxPoints = getRoundedPercent(maxPoints);
	const localPoints = getRoundedPercent(points);
	const localPointsPercent = getRoundedPercentToWholeNumber(pointsPercent);

	return (
		<div className={styles.pointsWrappper}>
			<div className={styles.points}>
				<div className={styles.pointsWithQuestion}>
					<span>
						{localPoints}&nbsp;{declinationOfNumber(localPoints, declinationArray)}
					</span>
					<TooltipCustom
						background="dark"
						title={translate('checklists_point_hint', language)}
						placement="top"
						followCursor={false}
					>
						<IconQuestion />
					</TooltipCustom>
				</div>
				<div className={styles.minMaxPoints}>
					<span>
						{translate('checklists_min', language)}
						{localMinPoints}
					</span>
					<span>
						{translate('checklists_max', language)}
						{localMaxPoints}
					</span>
				</div>
			</div>

			{condition && <ScorePercent condition={condition} scorePercent={localPointsPercent} />}
		</div>
	);
};

export default ScoreMinMax;
